import { store, getContext } from '@wordpress/interactivity';

const NAMESPACE = 'reqst/header';

store(NAMESPACE, {
	actions: {
		toggleMobileMenu() {
			const ctx = getContext();
			ctx.isMobileMenuOpen = !ctx.isMobileMenuOpen;
			document.body.classList.toggle('mobile-menu-open', ctx.isMobileMenuOpen);
		},
	},
});
